import React from 'react';
import {Redirect}  from 'react-router-dom'
import '../../styles/requestConfirmed.css';


export default class RequestConfirmed extends React.Component {

    constructor(props) {
        super(props);
        this.state={
            browseOtherArtworks : false
        }
    }
    handleBrowseOtherArtworksClick(){
        this.setState({
            browseOtherArtworks : true
        })
    }

    render() {
if(this.state.browseOtherArtworks){
    return(
        <Redirect push to="/artworks" />
    )
}

        return (
            <div className="col-sm-12 background-grey">
                <article className="post-88 page type-page status-publish hentry">
                    <div className="woocommerce">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                <div className="heading-welcome_">
                                    REQUEST SENT
                                    <hr className="line-category-name margin-auto"></hr>
                                </div>
                            </div>
                            <div className="col-sm-6 UploadPaintingCard text-center no-margin">
                                <img className="success-gold" src={require("../../assets/success_gold_png.png")}/>

                                <p className="success-text">Thank you, we will contact you on the status of your buy
                                    request via email.</p>

                                <button className="btn-black height-48" onClick={this.handleBrowseOtherArtworksClick.bind(this)}>
                                    Browse other artworks
                                </button>

                            </div>

                        </div>

                        <div className="row">
                            <div className="col-md-6 background-light-grey text-left">

                                <h1 className="heading-text text-left">What happens next ?</h1>

                                <ol className="list-success-text">
                                    <li>We will send you a payment link if the buyer confirms your buy request.</li>
                                    <li>You will need to complete the payment within 48 hours to complete thee
                                        payment.
                                    </li>
                                    <li>We ship your orders and share tracking details with you.</li>
                                </ol>

                            </div>
                        </div>

                    </div>
                </article>
            </div>

        )
    }
}


// WEBPACK FOOTER //
// ./src/components/requests_modals/request_confirmed.js